/**
 * View for configuring the KB touchpoints as part of the KB creation wizard
 */
define([
  "marionette",
  "modules/accountAdmin/kbWizardModal/kbTouchPoints/template/kbTouchPointsTemplate.html",
], function (Marionette, KbTouchPointsTemplate) {
  var KbTouchPointsView = {};

  KbTouchPointsView.kbTouchPointsLayout = Marionette.Layout.extend({
    template: KbTouchPointsTemplate,

    regions: {
      list: "#kbTouchPointList",
      responseTypeUsage: "#responseTypeUsage",
    },

    triggers: {
      "click #addTouchPoint": "addTouchPoint",
    },

    onRender: function () {
      var _this = this;
      this.$el.i18n();
      this.$el.find("input").on("keyup", function (e) {
        if (e.keyCode === 13) {
          _this.trigger("addTouchPoint");
        }
      });
    },

    getTouchPoint: function () {
      return this.$el.find("#touchPointName").val().trim();
    },

    clearTouchPoint: function () {
      this.$el.find("#touchPointName").val("");
    },

    touchPointError: function (errorMessage) {
      this.$el
        .find("#kbTouchPointError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },

    clearErrors: function () {
      this.$el.find("#kbTouchPointError").html("");
    },
  });

  return KbTouchPointsView;
});
